import { httpService } from '../http.service.js'

export const commentService = {
  query,
  getById,
  save,
  remove,
  toggleLike,
}

// שליפה של כל התגובות מהשרת עם אפשרות לפילטור
async function query(filterBy = {}) {
  try {
    // בניית פרמטרים של הפילטר
    const queryParams = new URLSearchParams(filterBy).toString()
    return await httpService.get(`comment?${queryParams}`)
  } catch (err) {
    console.error('Failed to fetch comments:', err)
    throw err
  }
}

// שליפה של תגובה לפי מזהה ייחודי
async function getById(commentId) {
  try {
    return await httpService.get(`comment/${commentId}`)
  } catch (err) {
    console.error(`Failed to get comment with ID ${commentId}:`, err)
    throw err
  }
}

// שמירה או עדכון של תגובה
async function save(comment) {
  try {
    if (comment._id) {
      // עדכון תגובה קיימת
      return await httpService.put(`comment/${comment._id}`, comment)
    } else {
      // יצירת תגובה חדשה
      return await httpService.post('comment', comment)
    }
  } catch (err) {
    console.error('Failed to save comment:', err)
    throw err
  }
}

// מחיקת תגובה לפי מזהה ייחודי
async function remove(commentId) {
  try {
    return await httpService.delete(`comment/${commentId}`)
  } catch (err) {
    console.error(`Failed to remove comment with ID ${commentId}:`, err)
    throw err
  }
}

// comment.service.remote.js
async function toggleLike(commentId, loggedInUserId) {
  try {
    // שולחים את loggedInUser._id תחת המפתח userId (כך שה-Backend יתייחס אליו נכון)
    return await httpService.put(`comment/${commentId}/like`, {
      userId: loggedInUserId,
    })
  } catch (err) {
    console.error('❌ Failed to toggle like:', err)
    throw err
  }
}
